import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import _size from 'lodash/size';
import _map from 'lodash/map';
import _reduce from 'lodash/reduce';
import _keys from 'lodash/keys';
import _noop from 'lodash/noop';
import { fetchColumnPreference, updateColumnPreference } from '@tekion/tekion-base/services/preferenceService';
import { tget } from '@tekion/tekion-base/utils/general';
import { EMPTY_OBJECT, EMPTY_STRING } from '@tekion/tekion-base/app.constants';
import MultiSortTriggerButton from './MultiSortTriggerButton';
import { toaster, TOASTER_TYPE } from '../../../NotificationWrapper';
function MultiSortTrigger(props) {
  var onSortApply = props.onSortApply,
    sortDetails = props.sortDetails,
    classNames = props.classNames;
  useEffect(function () {
    fetchSortPreferences();
  }, []);
  var onSortApplyHandler = function onSortApplyHandler(appliedSortItems) {
    setSortPreferences(appliedSortItems);
  };
  var fetchSortPreferences = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var assetType, applyInitSort, columnPreferences, sortPreferences;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            assetType = props.assetType, applyInitSort = props.applyInitSort;
            if (assetType) {
              _context.next = 3;
              break;
            }
            return _context.abrupt("return");
          case 3:
            _context.prev = 3;
            _context.next = 6;
            return fetchColumnPreference(assetType);
          case 6:
            columnPreferences = _context.sent;
            sortPreferences = _reduce(tget(columnPreferences, 'data.data.fieldPreferences', []), function (acc, item) {
              return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, item.field, item.sortOrder));
            }, EMPTY_OBJECT);
            applyInitSort(sortPreferences);
            _context.next = 14;
            break;
          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](3);
            toaster(TOASTER_TYPE.ERROR, __('Failed to fetch sort preferences'));
          case 14:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[3, 11]]);
    }));
    return function fetchSortPreferences() {
      return _ref.apply(this, arguments);
    };
  }();
  var setSortPreferences = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(sortPreferences) {
      var assetType;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            assetType = props.assetType;
            onSortApply(sortPreferences);
            if (assetType) {
              _context2.next = 4;
              break;
            }
            return _context2.abrupt("return");
          case 4:
            try {
              updateColumnPreference(assetType, {
                fieldPreferences: _map(_keys(sortPreferences), function (key) {
                  return {
                    field: key,
                    sortOrder: sortPreferences[key]
                  };
                })
              });
            } catch (e) {
              toaster(TOASTER_TYPE.ERROR, __('Failed to update sort preferences'));
            }
          case 5:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function setSortPreferences(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/React.createElement(MultiSortTriggerButton, _extends({}, props, {
    onSortApply: onSortApplyHandler,
    numberOfSortItems: _size(sortDetails),
    classNames: classNames
  }));
}
MultiSortTrigger.propTypes = {
  onSortApply: PropTypes.func.isRequired,
  assetType: PropTypes.string.isRequired,
  sortDetails: PropTypes.object,
  classNames: PropTypes.string,
  applyInitSort: PropTypes.func
};
MultiSortTrigger.defaultProps = {
  sortDetails: EMPTY_OBJECT,
  classNames: EMPTY_STRING,
  applyInitSort: _noop
};
export default MultiSortTrigger;